import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <>
      <SEO title="Page Not Found" />
      <div className="min-h-screen flex items-center justify-center bg-dark px-4">
        <div className="text-center">
          <motion.h1 
            className="text-6xl md:text-9xl font-bold text-accent mb-4"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            404
          </motion.h1>
          
          <motion.h2 
            className="text-2xl md:text-4xl font-bold mb-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Không Tìm Thấy Trang
          </motion.h2>
          
          <motion.p 
            className="text-light/80 max-w-md mx-auto mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            Trang bạn đang tìm kiếm không tồn tại hoặc đã được di chuyển.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <Link to="/" className="btn btn-primary">
              Quay Về Trang Chủ
            </Link>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
